import { Element } from "react-scroll";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { LogoCloud } from "../components/LogoCloud";
import { AudienceSplitSection } from "../components/AudienceSplitSection";
import { ProblemSection } from "../components/ProblemSection";
import { HumanTasksSection } from "../components/HumanTasksSection";
import { FeaturesBento } from "../components/FeaturesBento";
import { AssistantRolesSection } from "../components/AssistantRolesSection";
import { HowItWorksSection } from "../components/HowItWorksSection";
import { OutcomesSection } from "../components/OutcomesSection";
import { ForBusinessTeaser } from "../components/ForBusinessTeaser";
import { AutonomousFeaturesSection } from "../components/AutonomousFeaturesSection";
import { PricingSection } from "../components/PricingSection";
import { FAQSection } from "../components/FAQSection";
import { CTASection } from "../components/CTASection";
import { LatestPostsSection } from "../components/LatestPostsSection";
import { Footer } from "../components/Footer";
import { SEO } from "../components/SEO";
import { getHomePageSchemas, useSeo } from "../seo/schema";

export default function LandingPage() {
  const seo = useSeo();
  return (
    <div className="min-h-screen bg-background">
      <SEO schema={getHomePageSchemas(seo)} />
      <Header />
      <main className="pt-20 flex flex-col items-stretch">
        <Element name="home">
          <Hero />
        </Element>
        <div data-aos="fade-up" className="w-full">
          <LogoCloud />
        </div>
        <div data-aos="fade-up" className="w-full">
          <AudienceSplitSection />
        </div>
        <div data-aos="fade-up" className="w-full">
          <ProblemSection />
        </div>
        <div data-aos="fade-up" className="w-full">
          <Element name="human-tasks">
            <HumanTasksSection />
          </Element>
        </div>
        <div data-aos="fade-up" className="w-full">
          <Element name="product">
            <FeaturesBento />
          </Element>
        </div>
        <div data-aos="fade-up" className="w-full">
          <AssistantRolesSection />
        </div>
        <div data-aos="fade-up" className="w-full">
          <HowItWorksSection />
        </div>
        <div data-aos="fade-up" className="w-full">
          <OutcomesSection />
        </div>
        <div data-aos="fade-up" className="w-full">
          <AutonomousFeaturesSection />
        </div>
        <div data-aos="fade-up" className="w-full">
          <ForBusinessTeaser />
        </div>
        <div data-aos="fade-up" className="w-full">
          <Element name="pricing">
            <PricingSection />
          </Element>
        </div>
        <div data-aos="fade-up" className="w-full bg-background-muted">
          <Element name="faq">
            <FAQSection />
          </Element>
        </div>
        <div className="w-full">
          <LatestPostsSection />
        </div>
        <div data-aos="fade-up" className="w-full">
          <CTASection />
        </div>
      </main>
      <Footer hideCta />
    </div>
  );
}
